// extracted by mini-css-extract-plugin
module.exports = {"boxesContainer":"HomepageBody_boxesContainer__2T2BS","homeText":"HomepageBody_homeText__MW0Jv"};